<template>
  <div>

    <div id="symptoms" class="panel active">
      <div class="panel-content px-xs-4 px-md-0 pt-xs-4 pt-md-80">
        <h1 v-html="$getString('GLOBAL_SIGNS_OF_A_MOTOR_DELAY')"></h1>
        <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>

        <h2 id="symptoms-signs-label" v-html="ageGroup?.strings.symptomsSignsLabel"></h2>
        <p id="symptoms-concerns-label" class="smaller fg-sma-black-75" v-html="ageGroup?.strings.symptomsConcernsLabel"></p>
        
        <ul
          v-if="ageGroup"
          id="symptomlist"
          class="symptomlist bordered"
        >
          <li v-for="(symptom, index) in ageGroup.symptoms" :key="index">
            <div class="symptom-wrapper" ref="symptom">
              <div :class="[ 'symptom-header checkbox-container', { active: symptoms.indexOf(index) > -1 } ]" @click.prevent="select(index)">
                <div :class="[ 'checkbox', { checked: symptoms.indexOf(index) > -1 } ]"></div>
                <p v-html="symptom.label"></p>
                <div class="show-info" @click.stop="openSymptomPopup(index)"></div>
              </div>
              <div class="video-container">
                <video
                  v-if="symptom.video"
                  :poster="symptom.poster"
                  playsinline
                  controls
                  preload="none"
                  @play="onPlayVideo(index)"
                  @pause="onPauseVideo(index)"
                >
                  <source :src="symptom.video" type="video/mp4">
                </video>
                <img
                  v-if="playedVideos.indexOf(index) === -1"
                  class="video-trigger"
                  :src="symptom.poster"
                  alt="..."
                  @click.stop="playVideo(index)"
                >
              </div>
            </div>
          </li>
          <li>
            <div class="symptom-wrapper no-shadow">
              <div :class="[ 'symptom-header checkbox-container no-selection', { active: symptoms.indexOf(-1) > -1 } ]" @click.prevent="select(-1)">
                <div :class="[ 'checkbox', { checked: symptoms.indexOf(-1) > -1 } ]"></div>
                <p v-html="$getString('GLOBAL_NOT_CONCERNED')"></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="questionnaire-buttons container text-centered">
      <div class="tool-button previous mx-xs-2" @click="onPrevious" v-html="$getString('GLOBAL_BUTTON_BACK')"></div>
      <div :class="[ 'tool-button next mx-xs-2', { disabled: !next } ]" @click="onNext" v-html="$getString('GLOBAL_BUTTON_NEXT')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StageSymptoms',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      age: -1,
      ageGroup: null,
      symptoms: [],
      next: false,
      playedVideos: [],

      handlers: [],
    }
  },
  methods: {
    onPrevious() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Back`,
      } });

      this.$emit('action', { type: 'decrement-page' });
      this.$emit('action', { type: 'goto-stage', data: 'age-select' });
    },
    onNext() {
      if (!this.next) return;

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Continue`,
      } });

      this.$store.commit('SetData', { key: 'symptoms', value: this.symptoms });
      this.$emit('action', { type: 'increment-page' });

      this.initialiseQuestions();

      if (this.symptoms[0] > -1) {
        this.$emit('action', { type: 'goto-stage', data: 'questions' });
      } else {
        this.$emit('action', { type: 'goto-stage', data: 'add-symptoms' });
      }
    },
    openSymptomPopup(index) {
      const symptom = this.ageGroup.symptoms[index];

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_${symptom.analytics}_info`,
      } });

      this.$emit('action', { type: 'open-popup', data: {
        type: 'symptom',
        heading: symptom.label,
        items: symptom.popupList,
      }});
    },
    onPlayVideo(index) {
      const symptom = this.ageGroup.symptoms[index];

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_${symptom.analytics}_play_video`,
      } });
    },
    onPauseVideo(index) {
      const i = this.playedVideos.indexOf(index);
      this.playedVideos.splice(i, 1);
    },

    validateSymptomsArray(index) {
      if (index === -1) {
        if (this.symptoms.length > 0 && this.symptoms.indexOf(-1) === -1) {
          this.symptoms = [];
        }
      } else if (this.symptoms.indexOf(-1) > -1) {
        this.symptoms = [];
      }
    },
    select(index) {
      this.validateSymptomsArray(index);

      const arrIndex = this.symptoms.indexOf(index);
      if (arrIndex > -1) {
        this.symptoms.splice(arrIndex, 1);
      } else {
        this.symptoms.push(index);
        
        const analyticsValue = index > -1 
          ? this.ageGroup.symptoms[index].analytics 
          : 'Not_concerned';
        
        this.$emit('action', { type: 'log-analytics', data: {
          "category": 'Internal_link_click',
          "action": '/',
          "label": `{page_label}_${analyticsValue}`,
        } });
      }
      this.checkNextButton();
    },
    checkNextButton() {
      this.next = this.symptoms.length > 0;
    },
    playVideo(index) {
      this.playedVideos.push(index);
      const video = this.$refs['symptom'][index].querySelector('video');
      if (video) {
        video.play();
      }
    },

    getAnswers(question) {
      const currentQuestions = this.$store.getters.dataKey('questions');
      if (currentQuestions) {
        const currentIndex = currentQuestions.findIndex(item => item.index === question.index);
        if (currentIndex > -1) {
          return currentQuestions[currentIndex].answers;
        }
      }
      return [];
    },
    initialiseQuestions() {
      const buffer = this.ageGroup.questions.filter(question => this.symptoms.indexOf(question.symptom) > -1);
      const questions = [];
      buffer.forEach(question => {
        const questionCopy = JSON.parse(JSON.stringify(question));
        questionCopy.answers = this.getAnswers(question);
        questions.push(questionCopy);
      });
      this.$store.commit('SetData', { key: 'questions', value: questions });
      this.$emit('action', { type: 'set-pages', data: questions.length });
    },
  },
  mounted() {
    this.age = this.$store.getters.dataKey('age');
    this.symptoms = this.$store.getters.dataKey('symptoms');

    this.ageGroup = this.$store.getters.ageGroup;
    this.checkNextButton();
  },
}
</script>
